/**
 * Contas e textos dos pacotes, sem estado: valor avulso das sessões, desconto,
 * validade e ordem da lista. Usado pela lista e pelo formulário.
 */

/** 1200.5 -> "R$ 1.200,50" (sempre com centavos). */
export const formatBRL = (value) => `R$ ${(Number(value) || 0).toLocaleString('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})}`;

/** Procedimento da empresa pelo id gravado no pacote (o id chega como número ou texto). */
// eslint-disable-next-line eqeqeq
export const findProcedure = (procedures, procedureId) => procedures.find((p) => p.Id == procedureId);

/** Soma do preço de tabela de cada procedimento vezes a quantidade de sessões. */
export const totalProceduresValue = (packageProcedures, procedures) => packageProcedures.reduce((total, proc) => {
  const procedure = findProcedure(procedures, proc.procedure_id);
  return total + (procedure?.Price || 0) * proc.quantity;
}, 0);

/** Quantas sessões o pacote soma, de todos os procedimentos. */
export const totalSessions = (packageProcedures = []) => packageProcedures
  .reduce((total, proc) => total + (Number(proc.quantity) || 0), 0);

/** 71.62 -> "71,6" (uma casa, vírgula decimal). */
export const formatPercent = (value) => (Number(value) || 0).toLocaleString('pt-BR', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

/** Desconto do pacote sobre o valor avulso: { difference, percentage } (percentage com uma casa e vírgula, em texto). */
export const calculateDiscount = (totalValue, packagePrice) => {
  if (!packagePrice || packagePrice <= 0 || totalValue <= 0) return { difference: 0, percentage: 0 };
  const difference = totalValue - packagePrice;
  const percentageValue = totalValue > 0 ? (difference / totalValue) * 100 : 0;
  return {
    difference: Math.max(0, difference),
    percentage: formatPercent(Math.max(0, percentageValue)),
  };
};

/** Validade 0 ou vazia é "Não expira". */
export const isNoExpiry = (validityDays) => validityDays === 0 || validityDays === null;

export const validityLabel = (validityDays) => (isNoExpiry(validityDays) ? 'Não expira' : `${validityDays} dias`);

export const sessionsLabel = (count) => (count === 1 ? '1 sessão' : `${count} sessões`);

/** Ativos primeiro; dentro de cada grupo, por nome. */
export const sortPackages = (packages) => [...packages].sort((a, b) => {
  // eslint-disable-next-line eqeqeq
  if (a.active != b.active) return b.active ? 1 : -1;
  return a.name.localeCompare(b.name, 'pt-BR');
});
